import { render, staticRenderFns } from "./property-info.vue?vue&type=template&id=19b341b8&"
import script from "./property-info.vue?vue&type=script&lang=js&"
export * from "./property-info.vue?vue&type=script&lang=js&"
import style0 from "./property-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports